<section class="dynamic-collapse" *ngIf="title">
	<section class="dynamic-collapse-header">
		<div class="data-info" id="section-view-box">
			<h3>{{title}}
				<!-- <img *ngIf="title == 'property' && incomeProperty" src="../../assets/img/info-btn.svg" height="35px"
					placement="top"
					ngbTooltip="Property income is shown net of related expenses e.g. mortgage payments."> -->

				<div *ngIf="title == 'property' && incomeProperty" class="svg-container help-btn-svg-container"
					placement="top"
					ngbTooltip="Property income is shown net of related expenses e.g. mortgage payments.">
					<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 832.46 905"
						width="30px">
						
						<path
							d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
							transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
						<path
							d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
							transform="translate(-95.77 -59.5)" fill="#fff" />
						<path
							d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
							transform="translate(-95.77 -59.5)" class="svg-sign" />
						<path
							d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
							transform="translate(-95.77 -59.5)" class="svg-sign" />
					</svg>
				</div>
				<!-- Tooltip on mobile -->
				<div *ngIf="statusTooltipMobile && title == 'property'" class="container-tooltip-show-mobile">
					<div class="tooltip-show-mobile">Property income is shown net of related expenses e.g. mortgage
						payments.</div>
				</div>
				<div class="info-mark-mobile" *ngIf="questionMarkMobile && title == 'property'"
				(click)="toggleStatusTooltipMobile()">
					<!-- <img src="../../assets/img/info-btn.svg" height="35px" alt="section logo"> -->
					<div class="svg-container help-btn-svg-container">
						<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 832.46 905" width="30px">
							
							<path
								d="M806.85,839.55c-44.62,44.62-84.6,78-137.15,98.8-19.59,7.77-49.18,13.79-69.48,18-122.81,25.39-256.91-6-379.44-128.5-142.71-142.71-146.93-447.29,8-595.12C406.24,63.37,651.19,90.36,806.85,246,968.69,407.87,968.69,677.71,806.85,839.55Z"
								transform="translate(-95.77 -59.5)" fill="#4d4169" opacity="0.3" />
							<path
								d="M779.87,772c-44,44-83.43,76.92-135.26,97.45-19.31,7.65-48.49,13.59-68.51,17.72-121.12,25-253.37-5.9-374.2-126.73C61.17,619.74,57,319.37,209.79,173.58c175-167,416.57-140.38,570.08,13.14C939.47,346.32,939.47,612.43,779.87,772Z"
								transform="translate(-95.77 -59.5)" fill="#fff" />
							<path
								d="M501.68,262.27c-16.81-2.09-32.75,5.89-39.66,19.83-6.83,13.77-6.67,28.4.44,40.14a35,35,0,0,0,29.31,17.07h0l1.49,0c9.78,0,26.11-2,36-14.09,4.76-5.78,9.67-16.18,6-32.94C531.78,275.91,518.88,264.4,501.68,262.27Z"
								transform="translate(-95.77 -59.5)" class="svg-sign" />
							<path
								d="M489.15,692.82C467,692.82,457,692,457,638.58V407.22c0-25.42,13.63-32.2,39.83-32.2s41.49,5.87,41.49,41.49V625.87c0,50-12.74,67-23.76,67Z"
								transform="translate(-95.77 -59.5)" class="svg-sign" />
						</svg>
					</div>
				</div>
			</h3>
			<h2>
				<div class="total-count" *ngIf="total>=0">{{total | currency:'GBP':'symbol-narrow':'1.0'}}</div>
				<div class="total-count" *ngIf="total<0" style="color:red">
					({{total * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
				</div>
			</h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<div class="help-navigation"><span>Click on an item to explore further.</span></div>
			<div class="items-data-info" *ngFor="let item of items;let i = index;">
				<div class="view-info">
					<div class="view-data-info" (click)="view(item.Id,i)" id="{{item.Id}}">
						<div class="item-name">{{item.itemName}}</div>
						<div class="data">
							<div class="total-count" *ngIf="item.itemTotal>=0">
								{{item.itemTotal | currency:'GBP':'symbol-narrow':'1.0'}}</div>
							<div class="total-count" *ngIf="item.itemTotal<0" style="color:red">
								({{item.itemTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
							</div>
						</div>
					</div>
					<div *ngIf="item.Id==idToShow && show">
						<app-view-box [Id]="item.Id" [templateName]="templateName" [financialSummary]="'Yes'"
							[jointOwnersStats]="jointOwnersStats"></app-view-box>
					</div>
				</div>
			</div>
		</div>
	</section>
</section>